import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {OdmoriService} from '../odmori.service';
import {ToastrService} from 'ngx-toastr';
import {Globals} from "@app/services/globals.service";
import {FormControl, FormGroup, Validators, FormBuilder} from '@angular/forms';
import {BridgeService} from '@app/services/bridge/bridge.service';
import {environment} from '@env/environment';
import {DatePipe} from '@angular/common';
import {MyModalService} from '../modal/modal.service';
import {ConstantsService} from '@app/services/constants/constants.service';
import {Router} from '@angular/router';


@Component({
  selector: 'zahtjev-pregled',
  templateUrl: './zahtjev-pregled.component.html',
  styleUrls: ['./zahtjev-pregled.component.css']
})

export class ZahtjevPregled implements OnInit {
    reqId: string;
    request: any;

    refusalReason: string = '';
    isLoading: boolean;

    users = [];

    form: FormGroup;
    validator = new FormControl([], Validators.required);

    replacement_employee: string;
    replacement_id: number;
    showChangeEmployeeReplacementOption: boolean = false;
    cliUrl = environment.cliURL;

    creatorId: number;
    user: any;
    pending: boolean = false;
    pendingRefusal: boolean = false;
    showErrorBorder: boolean = false;
    validatorPosition: string;

    userData: any;

    pendingApproval: boolean = false;

    constructor(private activateRoute: ActivatedRoute, private odmoriService: OdmoriService, private toastr: ToastrService, 
        private formBuilder: FormBuilder, private globalsService: Globals, private bridge: BridgeService, private datePipe: DatePipe,
        private myModalService: MyModalService, private constants: ConstantsService, private router: Router) {}

    ngOnInit() {
        this.reqId = this.activateRoute.snapshot.params['reqId'];
        this.isLoading = true;

        this.getUsers();
        this.getRequestData(this.reqId);

        this.form = this.formBuilder.group({
            validators: this.validator
        });

        this.creatorId = this.constants.getLoggedInUserId();
    };

    getRequestData(reqId) {
        this.odmoriService.getRequestData(reqId).subscribe(result => {
            if (result.type === 'success') {
                this.isLoading = false;

                this.request = result.data;

                this.matchUserToName(this.request.employee_replacement_id[0]);

                this.validator.setValue([this.request.employee_replacement_id[0]]);

                this.userData = this.globalsService.getAllUsers().find(value => this.request.user_id == value.id);

                return;
            };

            this.toastr.error('Došlo je do greške prilikom vraćanja podataka. Molimo vas da se obratite korisničkoj podršci.');
        });
    };

    refuseRequest() {
        this.pendingRefusal = true;

        if(this.refusalReason === ''){
            this.toastr.info('Molimo vas unesite razlog odbijanja zahtjeva.');
            
            this.showErrorBorder = true;
            this.pendingRefusal = false;

            return;
        };

        this.validatorPosition = 'director';

        if(this.creatorId == this.request.manager_id) {
            this.validatorPosition = 'manager';
        };

        this.odmoriService.refuseRequest(this.reqId, this.refusalReason, this.validatorPosition).subscribe(result => {
            this.pendingRefusal = false;

            if (result.type === 'success') {
                const dateFrom = new Date(this.request.date_from);
                const dateTo = new Date(this.request.date_to);
                var description = 'Izvršni direktor vam je odbio odmor u periodu od ' + this.datePipe.transform(dateFrom, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(dateTo, 'dd-MM-yyyy') + '.';
                
                if(this.creatorId == this.request.manager_id) {
                    description = 'Menadžer vam je odbio odmor u periodu od ' + this.datePipe.transform(dateFrom, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(dateTo, 'dd-MM-yyyy') + '.';
                };

                var title = 'Status odmora u periodu od ' + this.datePipe.transform(dateFrom, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(dateTo, 'dd-MM-yyyy'); 

                this.sendNotification(title, description, this.request.user_id, this.request._id);

                this.toastr.success('Uspješno odbijen zahtjev.');

                this.router.navigate(['/odmori']);

                return;
            };

            this.toastr.error('Došlo je do greške prilikom odbijanja zahtjeva za odmor. Molimo vas da se obratite korisničkoj podršci.');
        });
    };

    getValidatorIds(data: number[]) {
        this.form.patchValue({'validators': data});
    };

    getUsers() {
        this.users = this.globalsService.getAllUsers().map(value => {
            const item = {
                id: value.id,
                full_name: value['first_name'] + ' ' + value['last_name'],
            };
            return item;
        });
    };

    changeReplacementEmployee() {
        this.showChangeEmployeeReplacementOption = true;
    };

    saveChangedReplacementEmployee() {
        this.pending = true;

        if(this.validator.value.length === 0) {
            this.toastr.info('Molimo vas izaberite ko vas mijenja tokom odsustva.');
            this.pending = false;

            return;
        };

        this.odmoriService.saveChangedReplacementEmployee(this.validator.value, this.request._id).subscribe(result => {
            this.pending = false;
            if (result.type === 'success') {
                this.matchUserToName(this.validator.value[0]);
                this.toastr.success(result.message);

                this.user = this.globalsService.getAllUsers().find(value => this.creatorId === value.id);

                var description = this.user.first_name + ' ' + this.user.last_name + ' vas je izabrao/la da ga/je mijenjate u u periodu od ' + this.datePipe.transform(this.request.date_from, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(this.request.date_to, 'dd-MM-yyyy') + '.';
                var title = 'Mijenjanje kolege/koleginice u periodu od ' + this.datePipe.transform(this.request.date_from, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(this.request.date_to, 'dd-MM-yyyy'); 

                this.sendNotification(title, description, this.validator.value, null);

                return;
            };

            this.toastr.error('Došlo je do greške prilikom promjene podatka. Molimo vas da se obratite korisničkoj podršci.');
        });
    };

    matchUserToName(replacementId) {
        this.users.forEach(item => {
            if(item.id === replacementId) {
                this.replacement_employee = item.full_name;
                this.replacement_id = item.id;
            };
        });
    };

    sendNotification(title, description, employee, reqId) {
        let link = null;

        if(reqId) {
            link = this.cliUrl + '/zahtjev-pregled/' + reqId;
        };
        
        const notif = {
            notification: {
                title: title,
                description: description,
                employers: employee,
                type: 'informacija',
                link: link
            }
        };
        
        this.bridge.sendDataViaBridge(notif);
    };

    deleteRequest() {
        this.myModalService.openModal(this.request);  
    };

    close() {
        this.showChangeEmployeeReplacementOption = false;
    };

    approveRequest() {
        this.pendingApproval = true;

        this.validatorPosition = 'director';
        let status: string = 'director_approved';

        if(this.creatorId == this.request.manager_id) {
            this.validatorPosition = 'manager';

            status = 'manager_approved';
        };

        let requestData = {
            '_id': this.request['_id']
        }

        this.odmoriService.changeStatusOfRequest(requestData, status, null).subscribe(result => {
            this.pendingApproval = false;

            this.user = this.globalsService.getAllUsers().find(value => this.creatorId === value.id);

            if (result.type === 'success') {
                var option = ' odmor/slobodan dan ';
                const dateFrom = new Date(this.request.date_from);
                const dateTo = new Date(this.request.date_to);

                var description = 'Menadžer i izvršni direktor su vam odobrili' + option + 'u periodu od ' + this.datePipe.transform(dateFrom, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(dateTo, 'dd-MM-yyyy') + '.';
                
                if(status === 'manager_approved') {
                    description = 'Menadžer vam je odobrio' + option + 'u periodu od ' + this.datePipe.transform(dateFrom, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(dateTo, 'dd-MM-yyyy') + '. Molimo vas sačekajte odobrenje izvršnog direktora.';

                    var descriptionForDirector = 'Menadžer je odobrio' + option + this.user.first_name + ' ' + this.user.last_name  + ' u periodu od ' + this.datePipe.transform(dateFrom, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(dateTo, 'dd-MM-yyyy') + '. Molimo vas validirajte zahtjev.';
                    var titleForDirector = 'Menadžer je odobrio' + option + this.user.first_name + ' ' + this.user.last_name  + ' u periodu od ' + this.datePipe.transform(dateFrom, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(dateTo, 'dd-MM-yyyy') + '.';
                    
                    this.sendNotification(titleForDirector, descriptionForDirector, [1, 14], this.request._id);
                };

                var title = 'Status odmora u periodu od ' + this.datePipe.transform(dateFrom, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(dateTo, 'dd-MM-yyyy'); 

                this.sendNotification(title, description, [+this.request.user_id], this.request._id);

                this.toastr.success('Uspješno odobren zahtjev.');

                this.router.navigate(['/odmori']);

                return;
            };

            this.toastr.error('Došlo je do greške prilikom odobravanja zahtjeva za odmor. Molimo vas da se obratite korisničkoj podršci.');
        });
    };
}